<div class="course-table table-section">
  <lx-price-lists-portal-table-header title="Course prices" [currency]="currency"></lx-price-lists-portal-table-header>
  <lx-price-lists-portal-course-table
    [data]="dataSource"
    [columnLabels]="columnLabels"
    [notationMarks]="notationMarks"
    [company]="company"
  ></lx-price-lists-portal-course-table>
  <lx-price-lists-portal-notes
    class="notes--white-theme"
    *ngIf="notes?.length > 0"
    [notes]="notes"
    [notationMarks]="notationMarks"
    [company]="company"
  ></lx-price-lists-portal-notes>
  <lx-price-lists-portal-course-start-dates [company]="company" [courseStartDates]="courseStartDates"></lx-price-lists-portal-course-start-dates>
</div>
